/*
 * @Descripttion: 
 * @Author: zhaozheng
 * @Version: 0.0.1
 * @Date: 2025-11-21 15:49:51
 * @LastEditors: zhaozheng
 * @LastEditTime: 2025-11-21 17:32:55
 */
import React, { VFC } from 'react';
import { css } from '@emotion/css';
import logo from '../assets/images/logo.png';

export const Footer: VFC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.top}>
          <div className={styles.left}>
             <img src={logo} alt="Token Map 词元映射" className={styles.logo} />
          </div>
          <div className={styles.right}>
            <a href="https://waytoagi.com" className={styles.link}>WaytoAGI</a>
            <a href="https://www.volcengine.com/" className={styles.link}>火山引擎</a>
            <a href="https://cq.daojiale.com/" className={styles.link}>到家了购房宝</a>
            <a href="https://cloud.baidu.com/" className={styles.link}>百度智能云</a>
            <a href="https://bailian.console.aliyun.com/" className={styles.link}>阿里云百炼</a>
          </div>
        </div>
        <div className={styles.bottom}>
          <span className={styles.copyright}>CompanyName @ 2026. All rights reserved.</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className={styles.beian}>豫ICP备2024102950号-4</a>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: css`
    position: relative;
    z-index: 10;
    width: 100%;
    background: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    color: #fff;
    padding: 25px 60px;
    pointer-events: auto;
    
    @media (max-width: 768px) {
      padding: 20px 20px;
    }
  `,
  content: css`
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  `,
  top: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
    }
  `,
  left: css`
    display: flex;
    align-items: center;
  `,
  logo: css`
    height: 40px;
    width: auto;
  `,
  right: css`
    display: flex;
    gap: 30px;
    align-items: center;
    flex-wrap: wrap;
    
    @media (max-width: 768px) {
      gap: 15px;
    }
  `,
  link: css`
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    opacity: 0.8;
    transition: opacity 0.2s;
    
    &:hover {
      opacity: 1;
    }
  `,
  bottom: css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
    padding-top: 20px;
    @media (max-width: 768px) {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  `,
  copyright: css`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
  `,
  beian: css`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    text-decoration: none;
    transition: opacity 0.2s;
    
    &:hover {
      opacity: 1;
    }
  `
};
